import { render } from "./RecommendationCom.vue?vue&type=template&id=e7863b3e&scoped=true"
const script = {}

import "./RecommendationCom.vue?vue&type=style&index=0&id=e7863b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7863b3e"]])

export default __exports__